export default __webpack_public_path__ + "static/media/AmongUs_Thumbnail.a2c39373.png";